import { Container } from "../atoms/Container";
import { Eyebrow } from "../atoms/Eyebrow";

type SitePricingProps = {
  mobile?: boolean;
};

export function SitePricing({ mobile = false }: SitePricingProps) {
  const pad = mobile ? 24 : 96;
  return (
    <section
      style={{
        paddingTop: mobile ? 64 : 96,
        paddingBottom: mobile ? 64 : 96,
      }}
    >
      <Container pad={pad}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: mobile ? "1fr" : "minmax(0,4fr) minmax(0,8fr)",
            gap: mobile ? 24 : 96,
            alignItems: "baseline",
          }}
        >
          <Eyebrow>What it costs</Eyebrow>
          <div style={{ maxWidth: 620 }}>
            <p
              style={{
                margin: 0,
                fontFamily: "var(--display)",
                fontSize: mobile ? 22 : 26,
                lineHeight: 1.35,
                color: "var(--text)",
                letterSpacing: "-0.015em",
              }}
            >
              Free for seven days. After that, eighty dollars a year.
            </p>
            <p
              style={{
                margin: "14px 0 0",
                fontFamily: "var(--ui)",
                fontSize: 13,
                color: "var(--text-3)",
                lineHeight: 1.6,
              }}
            >
              About six dollars and seventy cents a month, if you&apos;d rather think of it that
              way.
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
